import React from "react";

import ottoRocket from "../../assets/imgs/onboarding/otto-in-rocket.png";

export function ProgressBar({ progress }) {
  return (
    <div className="fixed left-0 w-full h-30 z-20 pt-20 bg-linear-to-b from-indigo-950 via-indigo-950 to-transparent">
      <div className="relative w-full h-2 bg-indigo-900 rounded-full -translate-y-10">
        <div
          className="h-2 bg-brand rounded-full transition-all"
          style={{ width: `${progress}%` }}
        />
        <img
          src={ottoRocket}
          alt="Otto in Rocket"
          className="absolute -top-9"
          style={{
            left: `calc(${progress}% - 24px + ${
              progress === 0 ? 24 : progress === 100 ? -24 : 0
            }px)`,
            width: 48,
            height: "auto",
            transform: "rotate(90deg)",
            transition:
              "left 0.3s cubic-bezier(0.4,0,0.2,1), transform 0.3s",
            pointerEvents: "none",
            userSelect: "none",
          }}
          draggable={false}
        />
      </div>
    </div>
  );
}
